





































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import DatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import moment from 'moment';

@Component({
  name: 'bpc-stripe-report-modal',
  components: {
    'bpc-date-picker': DatePicker,
  },
})
export default class StripeReportModal extends Vue {
  // PROPS
  @Prop({ type: String, default: 'invoice-validation-modal' })
  readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;

  // DATA
  showModalIndex = null;
  disabled = true;
  public labelInputAttributes = {
    for: 'global__',
    cols: 12,
  };

  formModel = {
    startDate: null,
    endDate: null,
  };

  public errorCustom = {
    startDate: null,
    endDate: null,
  };
  public maxDateAllowed = null;
  public minDateAllowed = null;
  public reportIdKey = null;
  public showErrors = false;
  public downloading = false;

  // COMPUTED
  get modalTitle() {
    return this.$t('global.modals.invoice_validation.title');
  }

  get modalBody() {
    return this.$t('global.modals.invoice_validation.body');
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // LIFECYCLE
  mounted() {
    this.initialize();
    if (this.showModal) {
      this.openModal();
    }

    this.getStripeAllowedReportDates();
  }

  initialize() {
    this.showModalIndex = Date.now();
    this.errorCustom = {
      startDate: null,
      endDate: null,
    };
    this.reportIdKey = null;
    this.showErrors = false;
    this.downloading = false;
  }

  async getStripeAllowedReportDates() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('stripe-reports');
    const path = `${basePath}/allowed-dates`;
    const res = await this.$bpcApi.get(path).toPromise();

    this.minDateAllowed = res.data['minAllowedDate'];
    this.maxDateAllowed = res.data['maxAllowedDate'];
    this.disabled = false;
  }
  // METHODS
  closeModal() {
    this.showModalIndex = Date.now();
    this.$emit('close-modal');
  }

  async onConfirmDownloadReport() {
    this.errorCustom = {
      startDate: null,
      endDate: null,
    };
    if (!this.validateForm()) {
      return;
    }
    this.downloading = true;
    const path = this.$bpcApiRouteHelper.getEntityPath('stripe-reports');
    // TODO validate dates;
    const res = await this.$bpcApi.post(path, this.formModel).toPromise();
    this.reportIdKey = res.data['reportIdKey'];
    this.listenToWebsocketInvoiceValidationChannel(this.reportIdKey);
  }

  validateForm() {
    const selectedStartDate = moment(this.formModel.startDate);
    const selectedEndDate = moment(this.formModel.endDate);
    const allowedStartDate = moment(this.minDateAllowed);
    const allowedEndDate = moment(this.maxDateAllowed);
    if (!this.formModel.startDate || !selectedStartDate.isSameOrAfter(allowedStartDate)) {
      this.errorCustom.startDate = this.$t('accounting.stripe_reports_date_after_or_equal', {
        date: this.$bpcHelper.formatDate(allowedStartDate),
      });
    }
    if (!this.formModel.endDate || !selectedEndDate.isSameOrBefore(allowedEndDate)) {
      this.errorCustom.endDate = this.$t('accounting.stripe_reports_before_or_equal', {
        date: this.$bpcHelper.formatDate(allowedEndDate),
      });
    }

    return !this.errorCustom.startDate && !this.errorCustom.endDate;
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  onCleanErrors(input) {
    this.errorCustom[input] = null;
  }

  async listenToWebsocketInvoiceValidationChannel(sessionCode) {
    // this.isValidatingInvoices = true;
    this.$bpcEcho
      .getStripeReportChannel(sessionCode)
      .listen('.BPC\\Accounting\\Events\\StripeReportCompleted', async data => {
        this.$bpcEcho.leaveStripeReportChannel(sessionCode);
        await this.downloadExportedFile(data.filePath, data.fileName);
        this.downloading = false;
      });
  }

  async downloadExportedFile(filePath: string, fileName: string) {
    return new Promise((resolve, reject) => {
      const basePath = this.$bpcApiRouteHelper.getEntityPath('stripe-reports');
      this.$bpcApi
        .download(`${basePath}/download`, `${fileName}.csv`, {
          params: {
            filePath: filePath,
          },
        })
        .subscribe(
          (res: BPCGenericApiResponse) => {
            // Download the response file
            // this.$emit('on-export-items');
            // this.downloadingExport = false;
            resolve(res);
          },
          error => {
            reject(error);
          },
        );
    });
  }

  generateUUIDv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // WATCHERS

  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
